import React from 'react'
import { Icon } from '@zambezi/sdk/icons'

const statusToIcon = {
  SUCCEEDED: 'confirmation-small',
  FAILED: 'error-small',
}

const activityToIcon = {
  SUCCEEDED: 'confirmation-small',
  FAILED: 'error-small',
  REJECTED: 'error-small',
  CANCELLED: 'error-small',
  SUBMITTING: 'clock-small',
  SUBMITTED: 'clock-small',
}

export default function StatusIcon({ status, className, isHistory = false }) {
  const iconName = isHistory ? activityToIcon[status] : statusToIcon[status]
  return iconName ? (
    <Icon
      aria-hidden="true"
      name={iconName}
      className={`${className} js-consent-icon js-status-${status}`}
    />
  ) : null
}
